import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import { INK, BODY, LINE, MAIL_RED, MAIL_RED_DARK } from "../scanning/tokens";
const Bar = styled.header`
  position: relative; z-index: 50; background: #fff; border-bottom: 1px solid ${LINE};
  .inner { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 18px; padding: 17px 0; }
  .brand { display: inline-flex; align-items: center; gap: 9px; color: ${INK}; text-decoration: none; }
  .dot { width: 9px; height: 9px; background: ${MAIL_RED}; border-radius: 50%; }
  .word { font-size: 21px; font-weight: 700; letter-spacing: -.7px; }
  .service { color: ${BODY}; font-size: 12px; margin-left: 4px; }
  nav { display: flex; align-items: center; gap: 20px; }
  nav a { font-size: 13px; color: ${BODY}; text-decoration: none; }
  nav a:hover { color: ${MAIL_RED}; }
  .pricing-menu { position: relative; }
  .pricing-menu summary { display: flex; align-items: center; gap: 6px; list-style: none; cursor: pointer; font-size: 13px; color: ${BODY}; }
  .pricing-menu summary::-webkit-details-marker { display: none; }
  .pricing-menu summary:hover, .pricing-menu[open] summary { color: ${MAIL_RED}; }
  .pricing-menu summary:focus-visible { outline: 3px solid ${MAIL_RED}; outline-offset: 4px; }
  .pricing-menu summary span { font-size: 10px; }
  .pricing-links { position: absolute; top: calc(100% + 14px); left: -16px; min-width: 240px; padding: 8px; background: #fff; border: 1px solid ${LINE}; border-radius: 8px; box-shadow: 0 12px 30px rgba(15,23,42,.12); }
  .pricing-links a { display: block; padding: 11px 12px; border-radius: 5px; white-space: nowrap; }
  .pricing-links a:hover, .pricing-links a:focus-visible { background: #FEF2F2; color: ${MAIL_RED_DARK}; }
  nav .signup { color: #fff; background: ${MAIL_RED}; padding: 10px 18px; border-radius: 5px; font-weight: 600; }
  nav .signup:hover { background: ${MAIL_RED_DARK}; color: #fff; }
  a:focus-visible, button:focus-visible { outline: 3px solid ${MAIL_RED}; outline-offset: 4px; }
  button { display: none; padding: 9px 13px; border: 1px solid ${LINE}; background: #fff; border-radius: 5px; color: ${INK}; font-size: 14px; }
  @media (max-width: 1199px) {
    button { display: block; } nav { display: none; width: 100%; flex-direction: column; align-items: stretch; gap: 0; }
    nav[data-open="true"] { display: flex; } nav a { padding: 12px 0; } nav .signup { text-align: center; margin-top: 10px; }
    .pricing-menu summary { padding: 12px 0; }
    .pricing-links { position: static; min-width: 0; margin-bottom: 10px; border: 0; border-left: 2px solid ${MAIL_RED}; border-radius: 0; box-shadow: none; padding: 0 0 0 10px; }
    .pricing-links a { padding: 11px 12px; white-space: normal; }
  }
  @media (max-width: 380px) { .service { display: none; } }
`;
const links = [["/how-mail-management-works/", "How it works"], ["/pricing/", "Pricing"], ["/parcel-forwarding-australia/", "Parcel forwarding"], ["/Testimonals/", "Reviews"], ["/contact-us/", "Contact"]];
const pricingLinks = [["/pricing/", "Pricing table"], ["/calculator/", "Mail cost calculator"], ["/parcel-forwarding-calculator/", "Mail forwarding cost estimator"]];
export default function MailHeader() {
  const [open, setOpen] = useState(false);
  const pricingRef = useRef(null);
  const closeMenus = () => {
    setOpen(false);
    if (pricingRef.current) pricingRef.current.open = false;
  };
  useEffect(() => {
    const closeOutside = (event) => {
      if (pricingRef.current && !pricingRef.current.contains(event.target)) pricingRef.current.open = false;
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape" && pricingRef.current && pricingRef.current.open) {
        pricingRef.current.open = false;
        pricingRef.current.querySelector("summary").focus();
      }
    };
    document.addEventListener("click", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("click", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);
  return <Bar><Container><div className="inner">
    <Link className="brand" to="/" aria-label="HotSnail mail scanning home" onClick={closeMenus}><span className="dot"/><span className="word">hotsnail</span><span className="service">Mail scanning &amp; forwarding</span></Link>
    <button type="button" aria-expanded={open} aria-controls="mail-navigation" onClick={() => { setOpen(!open); if (pricingRef.current) pricingRef.current.open = false; }}>Menu</button>
    <nav id="mail-navigation" aria-label="Mail services" data-open={String(open)}>
      {links.map(([to, label]) => to === "/pricing/" ? <details className="pricing-menu" ref={pricingRef} key={to}><summary>Pricing <span aria-hidden="true">▾</span></summary><div className="pricing-links">{pricingLinks.map(([href, text]) => <Link key={href} to={href} onClick={closeMenus}>{text}</Link>)}</div></details> : <Link key={to} to={to} onClick={closeMenus}>{label}</Link>)}
      <a href="https://members.hotsnail.com.au/Login">Log in</a><a className="signup" href="https://members.hotsnail.com.au/signup">Sign up</a>
    </nav>
  </div></Container></Bar>;
}
